"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
* Simple text page
*/
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var clientinfo_service_1 = require('../../clientinfo.service');
var AboutComponent = (function () {
    function AboutComponent(router, clientInfo) {
        this.router = router;
        this.clientInfo = clientInfo;
    }
    AboutComponent.prototype.ngOnInit = function () { };
    AboutComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-about',
            // templateUrl: './app/steps/about/about.template.html',
            template: require('./about.template.html'),
            directives: [router_deprecated_1.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _b) || Object])
    ], AboutComponent);
    return AboutComponent;
    var _a, _b;
}());
exports.AboutComponent = AboutComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/about/about.component.ts
 ** module id = 999
 ** module chunks = 1
 **/